import MainChannel from '../../shared/main-channel';
import ListPage from './connect/list-page';
import idea from '../../../assets/images/svg/idea.svg';
import back from '../../../assets/images/svg/back.svg';
import icon_search from '../../../assets/images/svg/search.svg';
import { useState } from 'react';

const ChannelFacebook = () => {
   const [search, setSearch] = useState('');
   const onChange = (e) => {
      setSearch(e.target.value);
   }

   return (
      <div className="app-connect-channel--container app-sh--connect-page">
         <div className="app-sh-connect-page--container">
            <div className="app-sh-connect-page--header">
               <div className="app-sh-connect-page--header-item">
                  <div className="app-sh-connect-page--header-title">
                     Chọn trang kết nối
                  </div>
                  <div className="app-sh-connect-page--header-desc">
                     Kết nối trang Facebook, Instagram để quản lý hội thoại trên Viettel Media.
                  </div>
               </div>
               <div className="app-sh-connect-page--filter">
                  <div className="app-sh-connect-page--filter-control">
                     <div className="app-stack app-stack--size-small app-stack--align-center">
                        <div className="app-stack--item">
                           <img src={icon_search} />
                        </div>
                        <div className="app-stack--item app-stack--item-fill">
                           <input className="app-sh-connect-page--filter-input" placeholder="Tìm kiếm trang" value={search} onChange={onChange} /></div>
                        <div className="app-stack--item"></div>
                     </div>
                  </div>
               </div>
            </div>
            <ListPage search={search} />
            <div className="app-sh-connect-page--request-fb-permission">
               <div className="app-sh-connect-page--request-fb-permission--header">
                  <div className="app-sh-connect-page--request-fb-permission--header__icon">
                     <img src={idea} />
                  </div>
                  <div className="app-sh-connect-page--request-fb-permission--header__title">
                     Không tìm thấy trang muốn kết nối?
                  </div>
               </div>
               <div className="app-sh-connect-page--request-fb-permission--description">
                  Nếu không tìm thấy trang cần kết nối, bạn vui lòng vào nhấn vào nút bên dưới để truy cập vào <b>Tiện ích
                     tích hợp</b> trên Facebook, sau đó nhấn vào app Viettel Media để chọn thêm trang.
               </div>
               <div className="app-sh-connect-page--request-fb-permission--btn-request-permission">
                  <a href="" className="app-btn app-btn-default" target="_blank">
                     Cài đặt Tiện ích tích hợp
                  </a>
               </div>
            </div>
            <div className="app-sh-connect-page--footer-container">
               <div className="app-sh-connect-page--footer">
                  <div className="app-sh-connect-page--footer-item">
                     <button type="button" className="app-btn app-btn-default app-sh-connect-page--footer-item-login">
                        <img src={back} />
                        <span>Trở về</span>
                     </button>
                  </div>
                  <div className="app-connect-page--footer-item"></div>
               </div>
            </div>
         </div>
      </div>
   )
}


export default ChannelFacebook;
